import apiClient from "../apiClient";

const resource = "promotions";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    add: payload => apiClient.post(`${resource}`, payload),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    complete: (id, payload) => apiClient.put(`${resource}/${id}/complete`, payload),
    delete: id => apiClient.delete(`${resource}/${id}`),
    approval: id => apiClient.put(`${resource}/${id}/approval`),
    employeesSearch: (employeeId) => apiClient.get(`${resource}/${employeeId}/EmployeesSearch`),

};